/**
 * Helper functions for working with Gutenberg's blocks.
 */

/**
 * @param {string} blockName
 * @return {string} Returns block ID value.
 */
export function generateBlockId( blockName ) {
	const randomString = ( length ) => {
		const chars = [];

		for ( let i = 0; i < length; i++ ) {
			const randomChar = Math.floor( Math.random() * 36 );
			chars.push( randomChar.toString( 36 ) );
		}

		return chars.join( '' );
	};

	const hash = randomString( 4 );
	return `${ blockName.replace( '/', '-' ) }-${ hash }`;
}
